import LeaveReviewComponent from "../components/reviewcomponents/leavereviewcomponent"

const ReviewPage =()=>
{
    return(<LeaveReviewComponent/>

    )
}

export default ReviewPage